// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"f07804b4","654":"35310309","979":"dafde4a3"}[chunkId] + ".chunk.js";
};